/**
 * Does the current environment (ie. browser) support Popover API?
 */
export function supportsPopover(): boolean {
    return HTMLElement.prototype.hasOwnProperty('popover');
}
